var React = require('react');

function None (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M50.5,0.5c-27.614,0-50,22.386-50,50s22.386,50,50,50s50-22.386,50-50S78.114,0.5,50.5,0.5z M50.5,90.5 c-22.091,0-40-17.908-40-40c0-22.091,17.909-40,40-40c22.092,0,40,17.909,40,40C90.5,72.592,72.592,90.5,50.5,90.5z"})),React.createElement("rect",{"x":"-9.5","y":"45.5","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -20.9176 50.5001)","width":"120","height":"10","key":1})]);
}

None.defaultProps = {"x":"0px","y":"0px","viewBox":"0.5 0.5 100 100","fill":"#ADADAD"};

module.exports = None;

None.default = None;
